// @flow
import React, { Component } from 'react'
import { Row, Col, Tabs } from 'antd'
import { StyledContent, StyledTabs } from './style'
import Overview from "./Overview";
import RecordsView from "./RecordsView";
import RiskProfile2 from "./RiskProfile2";
const TabPane = Tabs.TabPane

type Props = {
    match: Object,
}

type State = {
    dataReady: boolean,
    selectedTab: string,
}

class ViewTrades extends Component<Props, State> {

  state: State = {
    dataReady: false,
    selectedTab: this.props.match.params.tab || '1',
  }

  handleTabChange = (selectedTab: string) => {

        this.setState({ selectedTab })
  }

  render() {

    return (
      <Row>
        <Col span={24}>
          <StyledContent>
            <StyledTabs activeKey={this.state.selectedTab} onChange={this.handleTabChange}>
                <TabPane tab='Overview' key='1'>
                    <Overview tradeId={this.props.match.params.id}/>
                </TabPane>

                <TabPane tab='Risk Profile' key='2'>
                  <RiskProfile2 tradeId={this.props.match.params.id} />
                </TabPane>

                <TabPane tab='Trade Notes' key='3'>
                    <RecordsView tradeId={this.props.match.params.id}/>
                </TabPane>
            </StyledTabs>
          </StyledContent>
        </Col>
      </Row>
    )
  }
}

export default ViewTrades



// WEBPACK FOOTER //
// ./src/components/view-trades/index.js